import React from 'react'
import { AccordionDetails } from '@mui/material'

import useStyles, { StyledAccordion, StyledSummary } from './styles'

const Accordion = ({
  title,
  Icon = null,
  count = -1,
  expanded,
  toggleOpen,
  children
}) => {
  const classes = useStyles()

  return (
    <StyledAccordion expanded={expanded} elevation={0}>
      <StyledSummary expanded={expanded} onClick={toggleOpen}>
        <div className={classes.header}>
          {Icon && <Icon className='headerIcon' />}

          {title}

          {count > -1 && <div className='count'>{count}</div>}
        </div>
      </StyledSummary>

      <AccordionDetails>
        <div className={classes.content}>{children}</div>
      </AccordionDetails>
    </StyledAccordion>
  )
}

export default Accordion
